<template>
    <span>
        <header class="col-xs-12 npd podcast__header">
            <div class="container">
                <div class="row">
                    <h2>RESULATADO DE BUSQUEDA</h2>
                    <div id="#mybusqueda" class="col-xs-12 intbuscador">
                        
                            <input name="search" v-model="searchTerm" v-on:keyup.enter="banana" type="search">
                            <input type="submit" value="BUSCAR" >
                        
                    </div>
                    <p v-if="resultados" class="text-center">Resultados aproximados: {{ Object.keys(resultados).length}}</p>
                     <p v-else class="text-center">Resultados aproximados: Sin resultados </p>
                </div>
            </div>
        </header>
        <div v-if="loaded=='true'">
            <section class="col-xs-12 block resultado">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 npd resultado__item" v-for="resultado in resultados">
                            <figure class="col-xs-2 col-sm-3 col-md-1 npd">
                                <router-link v-if="resultado.type=='locutores'" :to="{ name: 'locutor', params: { locutor: resultado.slug }}">
                                         <img v-if="resultado.thumb" v-bind:src="resultado.thumb" alt="">
                                    <img v-else  v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
                                </router-link>  
                                <router-link v-else-if="resultado.type=='programas'" :to="{ name: 'programa', params: { elprograma: resultado.slug }}">
                                       <img v-if="resultado.thumb" v-bind:src="resultado.thumb" alt="">
                                    <img v-else  v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
                                </router-link>
                                <router-link v-else-if="resultado.type=='post'" :to="{ name: 'post', params: { name: resultado.slug }}">
                                       <img v-if="resultado.thumb" v-bind:src="resultado.thumb" alt="">
                                    <img v-else  v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
                                </router-link>
                                <router-link v-else :to="{}">
                                      <img v-if="resultado.thumb" v-bind:src="resultado.thumb" alt="">
                                    <img v-else  v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
                                </router-link>
                            </figure>
                            <article class="col-xs-10 col-sm-4 col-md-11 resultado__desarrollo">
                                <router-link v-if="resultado.type=='locutores'" :to="{ name: 'locutor', params: { locutor: resultado.slug }}">
                                        <h3>{{resultado.title}}</h3>
                                </router-link>  
                                <router-link v-else-if="resultado.type=='programas'" :to="{ name: 'programa', params: { elprograma: resultado.slug }}">
                                      <h3>{{resultado.title}}</h3>
                                </router-link>
                                <router-link v-else-if="resultado.type=='post'" :to="{ name: 'post', params: { name: resultado.slug }}">
                                      <h3>{{resultado.title}}</h3>
                                </router-link>
                                <router-link v-else :to="{}">
                                     <h3>{{resultado.title}}</h3>
                                </router-link>
                                <div class="col-xs-12 npd resultado__categoria">
                                    <a v-if="resultado.type!=='post'" href="#">
                                        <span>
                                            {{resultado.type | UpperFirst}}
                                        </span>
                                    </a>
                                    <a v-else href="#">
                                        <span>
                                            {{resultado.category[0].cat_name | UpperFirst}}
                                        </span>
                                    </a>

                                </div>
                                <p><a href="#">
                                    {{resultado.excerpt}}
                                </a></p>
                            </article>
                        </div>
                    </div>
                </div>
            </section>
        <div v-else>
            <section class="col-xs-12 block resultado">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 npd resultado__item">
                            <figure class="col-xs-2 col-sm-3 col-md-1 npd">
                                <a href="#">
                                    <img v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
                                </a>
                            </figure>
                            <article class="col-xs-10 col-sm-4 col-md-11 resultado__desarrollo">
                                <a href="#">
                                    <h3>Sin resultados</h3>
                                </a>
                                <div class="col-xs-12 npd resultado__categoria">
                                    <a href="#">
                                        <span>
                                            Busqueda
                                        </span>
                                    </a>
                                    <a>
                                          http://obedira.com.py/
                                    </a>
                                </div>
                                <p>
                                    <a href="#">
                                        No se encontraron resultados para su busqueda.
                                    </a>
                                </p>
                            </article>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </span>
</template>


<script>
export default {
    mounted: function() {
        const vm = this;
        console.log('Palabra clave: '+vm.$route.params.s);
        //console.info(vm.$route.params);
        if ( vm.$route.params.s ) {
            vm.getResultadoBusqueda(vm.$route.params.s);
        }
        vm.reInitialize();
    },
    watch: {
                // call method if the route changes
                '$route': 'reInitialize',
                /*'$route.params.s': function(s){
                    this.getResultadoBusqueda(s);
                    console.log(s);
                }*/
            },
    data: function () {
        return {
            theme_url:rtwp.theme_url,
            loaded: 'false',
            pageTitle: '',
            totalCount: '',
            currentPage: '',
            prevPage: '',
            nextPage: '',
            showNext: 'false',
            showPrev: 'false',
            postPerPage: '12',
            totalPages: '',
            searchTerm:'',
            resultados:'',
        };

    }, 
    methods: {
        reInitialize: function() {
            const vm = this;
            //console.log('00000Palabra clave: ');
            //console.info(vm.$route.params);
            //console.log(vm.searchTerm);
            vm.getResultadoBusqueda(vm.$route.params.s);
        },
        getResultadoBusqueda: function(palabra) {
            const vm = this;
            vm.loaded = 'false';
            vm.$http.get( 'sss/busqueda/?s='+palabra)
            .then( ( res ) => {
                vm.resultados = res.data;
                vm.loaded = 'true';
            // alert(vm.loaded);
            //console.log('Cargado y terminado00000');
            vm.$nextTick(function () {
             console.log('Cargado y terminado');
             console.log(vm.resultados);
         });
        } )
            .catch( ( res ) => {
                console.log( `Something went wrong : ${ res }` );
            } );
        },
        banana: function (){
            const vm = this;
            console.log(vm.searchTerm);
            vm.$router.push(
            {   name: 'search', 
                params: {    
                    s: vm.searchTerm
                }}); 
        }
    },
    filters: {
        UpperFirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
        };
</script>



// WEBPACK FOOTER //
// search.vue?84a0fa56